import SearchListHeaderComponent from '@atoms/SearchListHeaderComponent';
import { Divider, Text, View } from '@components/primitives';
import { useNavigation, RouteProp } from '@react-navigation/native';
import appStyles from '@root/appStyles';
import colors from '@theme/colors';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS } from '@utils/analytics/constants';
import { formatUnderScoreLowerCase } from '@utils/utils';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity, FlatList } from 'react-native';
import styles from './styles';
// Define types
interface Region {
  id: number;
  name: string;
  code?: string;
}

type GGRegionsRouteParams = {
  params: {
    regionsData: Region[];
    setSelectedRegion: (region: Region) => void;
  };
};

type GGRegionsProps = {
  route: RouteProp<GGRegionsRouteParams, 'params'>;
};

function getItemSeperatorComponent() {
  return () => <Divider style={styles.dividerStyle} color={colors.neutral.mist} />;
}

const GGRegions: React.FC<GGRegionsProps> = ({ route }) => {
  const navigation = useNavigation();
  const { t } = useTranslation('common');

  const { regionsData, setSelectedRegion } = route.params;

  const [searchData] = useState<Region[]>(regionsData);
  const [filteredData, setFilteredData] = useState<Region[]>(regionsData);

  useEffect(() => {
    navigation.setOptions?.({ title: t('bp.selectRegion') });
  }, []);

  return (
    <View style={appStyles.safeAreaView}>
      <FlatList
        testID="fltLstRegions"
        style={styles.flRegionsStyles}
        stickyHeaderIndices={[0]}
        ListHeaderComponent={
          <SearchListHeaderComponent
            searchKey="name"
            searchData={searchData}
            setFilteredData={setFilteredData}
            searchPlaceholder={t('bp.regionSelect')}
          />
        }
        ItemSeparatorComponent={getItemSeperatorComponent()}
        data={filteredData}
        keyExtractor={item => item.id.toString()}
        renderItem={({ item, index }) => (
          <TouchableOpacity
            testID={`btnRegionSelect${index}`}
            onPress={() => {
              const e = AMPLITUDE_CONSTANTS.BillPayment.PostPaid.pdamAreaSelected;
              const { name, attributes } = e;
              AmplitudeHelper.logEvent(name, {
                [attributes.product_code]: formatUnderScoreLowerCase(item?.code),
              });
              setSelectedRegion(item);
              navigation.goBack();
            }}>
            <Text variant="md-normal" style={styles.txtRegionsStlyles}>
              {item.name}
            </Text>
          </TouchableOpacity>
        )}
      />
    </View>
  );
};

export default GGRegions;
